
import { computed, defineComponent } from 'vue';
import { MutationTypes } from '@/store/mutations';
import { useStore } from '@/store';

export default defineComponent({
    name: 'NotificationSettingsForm',
    setup () {
        const store = useStore();
        const notificationPeriods = computed(() => store.state.periods);
        const id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
        const periodSelectId = 'notification-settings-form-' + id + '-2';
        const period = computed({
            get: () => store.state.notificationData.period,
            set: value => store.commit(MutationTypes.SetNotificationPeriod, parseInt('' + value, 10))
        });

        return {
            periodSelectId,
            notificationPeriods,
            period
        };
    }
});
